import { Guid } from 'guid-typescript';

export class CompanyContext {
  CompanyIdentifier: Guid = Guid.parse(Guid.EMPTY);
}
